import axios from "axios";
import { attachApiErrorToast, notifyApiError } from "../../helpers/apiNotify";

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});
attachApiErrorToast(API, { fallback: "File request failed" });

export const handleFilesDownload = async (data) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}file/${data.userId}/downloadapplicationfiles/${data.applicationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/zip",
          Authorization: `${data.authToken}`,
        },
      }
    );

    if (!response.ok) {
      let body = null;
      try {
        body = await response.json();
      } catch (_) {
        /* ignore non-JSON error bodies */
      }
      notifyApiError(
        {
          status: response.status,
          data: body,
          message: body?.message || body?.error,
        },
        "Failed to download files"
      );
      return;
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `application_${data.applicationId}_files.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading files:", error);
    notifyApiError(error, "Failed to download files");
  }
};

const getImageAsBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getSignature = async (data) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}file/${data.userId}/applicationsignature/${data.applicationId}`,
      {
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${data.authToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch files");
    }

    const imageBlob = await response.blob();

    // Create a local URL for the fetched image blob
    const imageObjectURL = URL.createObjectURL(imageBlob);
    return getImageAsBase64(imageObjectURL);
  } catch (error) {
    console.error("Error downloading files:", error);
  }
};
export const downloadCertificate = async (
  id,
  authToken,
  setDownloadLoader = () => {}
) => {
  setDownloadLoader(id);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}file/${id}/downloadCertificate`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download the signature file");
      setDownloadLoader(null);
    }

    // Convert the response to a Blob object
    const blob = await response.blob();

    // Create a temporary URL for the Blob object
    const url = window.URL.createObjectURL(new Blob([blob]));

    // Create a temporary anchor element to trigger the download
    const link = document.createElement("a");
    link.href = url;

    // Use the file name returned from the backend
    const contentDisposition = response.headers.get("Content-Disposition");
    const fileName =
      contentDisposition?.split("filename=")[1]?.replace(/['"]/g, "") ||
      "signature.png";

    link.setAttribute("download", fileName); // File name for download

    // Append link to the document, click it to trigger the download, and then remove it
    document.body.appendChild(link);
    link.click();
    link.remove();
    setDownloadLoader(null);
  } catch (error) {
    setDownloadLoader(null);
    console.error("Error downloading signature file:", error);
  }
};
